export const isSpoofer = () => {
  return window.AppContext?.isSpoofer === 'true';
};

export const DEFAULT_LOCALE = 'en_US';
/**
 * Returns locale codes separated by an underscore
 * @returns {string}
 * @example 'en_US'
 * @example 'fr_FR'
 */
export const getLocale = () => {
  if (!window.AppContext?.locale) {
    return DEFAULT_LOCALE;
  }
  return window.AppContext?.locale as string;
};

/**
 * Returns locale codes separated by a hyphen
 * @returns {string}
 * @example 'en-US'
 * @example 'fr-FR'
 */
export const getFormattedLocale = () => {
  const locale = getLocale();
  return locale.replace('_', '-');
};

export const getCountryCodeFromContext = (): string => {
  return window.AppContext?.countryCode as string;
};

export const isAdsAssistantIngressEnabled = (): boolean => {
  // TODO - https://i.amazon.com/issues/e0e7ddc0-7cec-468c-bacb-b239d1888c9c
  return false;
};
